import {Alert, Box, CircularProgress, Container, Stack} from "@mui/material";
import React, {PropsWithChildren} from "react";
import {BrandingBar} from "./branding-bar";

interface AppLayoutProps {
	showBrandingBar: boolean;
	loading?: boolean;
	error?: Error;
	gutterTop?: boolean;
	/**
	 * Constrain the layout to the viewport height with the branding bar pinned to the top, so the page content
	 * can manage its own scrolling (e.g. a scrollable body above a fixed footer). Defaults to natural document flow.
	 */
	fillViewport?: boolean;
}

export function AppLayout(
	{showBrandingBar, loading, error, gutterTop, fillViewport, children}: PropsWithChildren<AppLayoutProps>,
) {
	const content = (
		<>
			{(loading || error !== undefined) && (
				<Container
					maxWidth="md"
					sx={{
						mt: showBrandingBar ? 2 : 0,
					}}
				>
					{loading && (
						<Stack
							direction="column"
							alignItems="center"
						>
							<CircularProgress />
						</Stack>
					)}

					{error && (
						<Alert severity="error">
							{error.message ?? "Error"}
						</Alert>
					)}
				</Container>
			)}

			{children}
		</>
	);

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				...(fillViewport ? {height: "100dvh"} : {}),
			}}
		>
			{showBrandingBar && <BrandingBar />}

			<Box
				sx={{
					width: "100%",
					mt: gutterTop ? 2 : 0,
					...(fillViewport
						? {flex: 1, minHeight: 0, display: "flex", flexDirection: "column"}
						: {}),
				}}
			>
				{content}
			</Box>
		</Box>
	);
}
